(function () {
  var root = document.querySelector('[data-magica-home]');
  if (!root) {
    return;
  }

  var revealItems = root.querySelectorAll('[data-reveal]');
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.16 });

    revealItems.forEach(function (item) {
      revealObserver.observe(item);
    });
  } else {
    revealItems.forEach(function (item) {
      item.classList.add('is-visible');
    });
  }

  var cards = root.querySelectorAll('.magica-review-card');
  var activeCard = 0;
  if (cards.length > 1) {
    window.setInterval(function () {
      cards[activeCard].classList.remove('is-active');
      activeCard = (activeCard + 1) % cards.length;
      cards[activeCard].classList.add('is-active');
    }, 4200);
  }

  var faq = root.querySelector('[data-magica-faq]');
  if (faq) {
    faq.addEventListener('click', function (event) {
      var item = event.target.closest('.magica-faq__item');
      if (!item) {
        return;
      }

      var isOpen = item.classList.contains('is-open');
      faq.querySelectorAll('.magica-faq__item').forEach(function (button) {
        button.classList.remove('is-open');
        button.setAttribute('aria-expanded', 'false');
        var icon = button.querySelector('small');
        if (icon) {
          icon.textContent = '+';
        }
      });

      if (!isOpen) {
        item.classList.add('is-open');
        item.setAttribute('aria-expanded', 'true');
        var itemIcon = item.querySelector('small');
        if (itemIcon) {
          itemIcon.textContent = '-';
        }
      }
    });
  }

  var heroBg = root.querySelector('.magica-hero__bg');
  window.addEventListener('scroll', function () {
    if (heroBg) {
      heroBg.style.setProperty('--magica-scroll', window.scrollY * 0.08 + 'px');
      heroBg.style.transform = 'scale(1.06) translateY(' + window.scrollY * 0.04 + 'px)';
    }
  }, { passive: true });

  var sticky = root.querySelector('[data-magica-sticky]');
  if (sticky) {
    window.addEventListener('scroll', function () {
      sticky.classList.toggle('is-visible', window.scrollY > 720);
    }, { passive: true });
  }

  var countdown = root.querySelector('[data-countdown]');
  var seconds = 3 * 60 * 60;
  if (countdown) {
    window.setInterval(function () {
      seconds = seconds > 0 ? seconds - 1 : 3 * 60 * 60;
      var hours = Math.floor(seconds / 3600);
      var minutes = Math.floor((seconds % 3600) / 60);
      var secs = seconds % 60;
      countdown.textContent = [hours, minutes, secs].map(function (value) {
        return value < 10 ? '0' + value : value;
      }).join(':');
    }, 1000);
  }
})();
